import Authentication from './modules/authentication';
import Data from './modules/data';
import Url from './modules/url';
import BrowserTab from './modules/browsertab';
import Table from './modules/table';
import String from './modules/string';
import Validation from './modules/validation';
import Variables from './modules/variables';
import General from './modules/general';

import Calculators from './modules/calculators';

import Vue from 'vue';

let mixins = [
    Authentication,
    Data,
    Url,
    Table,
    String,
    Validation,
    Calculators,
    Variables,
    General,
    BrowserTab
];

mixins.forEach((mixin) => {
    Vue.mixin(mixin);
});

// DEBUGGING PURPOSES = NEED TO DELETE
// Vue.mixin({
//     created() {
//         console.log('[created] ' + this.$options.name)
//     },
// });
